module.exports = __webpack_public_path__ + "img/c81cb45.jpg";